import React from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { WebService } from "../../Services/WebService";
import { Form, FormInputDropdown } from "../Form";
import { useDispatch } from "react-redux";
import * as yup from "yup";
import { ActionPermission } from "../PageInfo";
import { useNavigate } from "react-router-dom";
const { forwardRef, useState, useImperativeHandle } = React;
const AddEditRolePermission = (prop, ref) => {
  const [permission] = useState({
    ManageAdd: ActionPermission("Roles - Add"),
  });
  var nevigate = useNavigate();
  const dispatch = useDispatch();
  const [show, setShow] = useState(false);
  const [data, setData] = useState({ RolePermission: {} });
  useImperativeHandle(ref, () => ({
    openModal: async () => {
      setShow(true);
      const data = await WebService({
        endPoint: `RolePermission/getRolesAndPermissionsMasterList`,
        dispatch,
      });
      data.permission = data.permission.map((v) => {
        return {
          value: v.PermissionId || "" || null || undefined,
          text: v.Permission,
        };
      });
      data.roles = data.roles.map((v) => {
        return {
          value: v.RoleId || "" || null || undefined,
          text: v.RoleName,
        };
      });
      setData(data);
    },
  }));
  const handleClose = () => {
    setShow(false);
    setData({ RolePermission: {} });
  }
  const requiredMessage = "This is a required field";
  const schema = yup
    .object()
    .shape({
      PermissionId: yup.string().trim().required(requiredMessage),
      RoleId: yup.string().trim().required(requiredMessage),
    })
    .required();
  const onSubmit = async (data) => {
    await WebService({
      endPoint: "RolePermission/Create",
      body: data,
      dispatch,
    });

    handleClose();
    prop.callBackEvent();
  };

  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>Add Role-Permission</Modal.Title>
      </Modal.Header>
      <Form
        defaultValues={data.RolePermission}
        onSubmit={onSubmit}
        validationSchema={schema}
      >
        <Modal.Body className="p-4">
          <div className="row d-flex justify-content-center">
            <div className="col-md-3">
              <label style={{ color: '#5a5a5a',fontFamily: 'sans-serif',fontSize: '14px'}}>Select Role</label>
            </div>
            <div
              className={`${
                permission.ManageAdd === true ? "col-md-9" : "col-md-9"
              }`}
            >
              <FormInputDropdown
                name="RoleId"
                ddOpt={data.roles}
                isRequired="true"
              ></FormInputDropdown>
            </div>
          </div>
          <div className="row d-flex justify-content-center pt-2">
            <div className="col-md-3">
              <label style={{ color: '#5a5a5a',fontFamily: 'sans-serif',fontSize: '14px'}}>Select Permission</label>
            </div>
            <div
              className={`${
                permission.ManageAdd === true ? "col-md-6" : "col-md-9"
              }`}
            >
              <FormInputDropdown
                name="PermissionId"
                ddOpt={data.permission}
                isRequired="true"
              ></FormInputDropdown>
            </div>

            {permission.ManageAdd && (
              <div className="col-md-3 text-end">
                <Button
                  variant="outline-primary"
                  size="sm"
                  onClick={() => nevigate("/Roles")}
                >
                  Add Role
                </Button>
              </div>
            )}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            id="btnRolePermissionSubmit"
            variant="outline-primary"
            type="submit"
          >
            {" "}
            Submit
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};
export default forwardRef(AddEditRolePermission);
